// extracted by mini-css-extract-plugin
module.exports = {"tipJar":"TipJar_tipJar__1gY_4","firstDropdown":"TipJar_firstDropdown__2CIKj","middleDropdown":"TipJar_middleDropdown__33xy8"};